import React from 'react';
import { Outlet } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import FraudMarqueeBar from './components/FraudMarqueeBar';
import './css/Common.css'

function Layout() {
  return (
    <div className="wrapper">
    <div id="snackbar"></div>
    <header className="">
      <Header />
    </header>
    <main className="">
    <Outlet />  
    </main>
    <footer className="">
      <Footer />
    </footer>
    <FraudMarqueeBar />
  </div>
  )
}

export default Layout;